import { Typography } from "@mui/material";
import { Box, SxProps, Theme } from "@mui/system";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../styles/theme";
import { ROUTES } from "../../../constant/common.constant";
import { Button } from "../Button";

const styles: Record<string, SxProps<Theme>> = {
  container: {
    minWidth: "100vw",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  message: {
    fontWeight: 600,
    color: palette.blue.primary,
  },
};

export const ErrorFallback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box role="alert" sx={styles.container} gap={6}>
      <Typography variant="h3" sx={styles.message}>
        Something went wrong
      </Typography>
      <Button onClick={() => navigate(ROUTES.HOME)}>
        {t("general.backToHome")}
      </Button>
    </Box>
  );
};
